import { getCurrentInstance } from 'vue'

import { VueScreenObject } from 'vue-screen/types'

export function useScreen () {
  // TODO: Replace with Vue Screen's useScreen() when we get to Vue 3
  return getCurrentInstance()?.proxy.$screen as VueScreenObject
}
